import UAParser from 'ua-parser-js';

const isAndroidBridge = typeof window !== 'undefined' && Boolean(window.nativeBridge);
const isIOSBridge =
  typeof window !== 'undefined' && Boolean(window.webkit?.messageHandlers?.nativeBridge);

export const isWebView = isAndroidBridge || isIOSBridge;

const parser = typeof window === 'undefined' ? null : new UAParser();

export const os = parser?.getOS();
export const browser = parser?.getBrowser();
export const device = parser?.getDevice();
export const isMobile = device?.type === 'mobile';
